import { Button } from "@/components/shared/Button";
import { Chip } from "@/components/shared/Chip";
import { CalendarIcon, PinIcon } from "@/components/shared/Icons";
import { CtaTrust } from "@/components/shared/CtaTrust";
import { ANCHORS } from "@/config/routes";
import { ASSETS } from "@/config/assets";
import { WORKSHOP } from "@/config/workshop";

export function Hero() {
  return (
    <section className="hero" id="top" aria-label="Körperintelligenz – Live-Workshop">
      {ASSETS.heroVideo ? (
        <video
          className="hero-video"
          autoPlay
          muted
          loop
          playsInline
          poster={ASSETS.heroPoster || undefined}
          data-testid="hero-video"
        >
          <source src={ASSETS.heroVideo} />
        </video>
      ) : null}

      <div className="wrap hero-content">
        <p className="hero-eyebrow reveal is-visible">Live-Workshop · Schledehausen</p>

        <h1 className="hero-title reveal is-visible">
          <span>Körper</span>
          <span>Intelligenz</span>
        </h1>

        <p className="hero-sub reveal is-visible">Gleichgewicht ist das Fundament jeder Bewegung.</p>

        <p className="hero-sub-2 reveal is-visible" data-testid="hero-sub-2">
          Entdecke in vier praxisnahen Stunden, wie dein Gleichgewicht Stabilität, Orientierung und
          Bewegungsqualität beeinflusst – und wie du dieses Wissen direkt im Alltag anwenden kannst.
        </p>

        <div className="hero-meta reveal is-visible">
          <Chip icon={CalendarIcon} data-testid="hero-chip-date">
            {`${WORKSHOP.dateShort} · ${WORKSHOP.time}`}
          </Chip>
          <Chip icon={PinIcon} data-testid="hero-chip-location">
            {WORKSHOP.locationShort}
          </Chip>
        </div>

        <div className="hero-cta reveal is-visible">
          <Button href={ANCHORS.buchung} data-testid="hero-primary-cta">
            Platz sichern
          </Button>
          <Button href={ANCHORS.erlebnis} variant="ghost" data-testid="hero-secondary-cta">
            Was dich erwartet
          </Button>
        </div>

        <CtaTrust className="reveal is-visible" />

        <p className="hero-price reveal is-visible" data-testid="hero-price">
          {WORKSHOP.pricing.early.amount} € Frühbucher · {WORKSHOP.pricing.regular.amount} € regulär ·
          Frühbucher bis {WORKSHOP.earlyBirdUntil}
        </p>

        <p className="hero-note reveal is-visible">Begrenzte Plätze · Maximal 20 Teilnehmer</p>
      </div>

      <div className="scroll-cue" aria-hidden="true">
        <span className="bar" />
        <span>Mehr</span>
      </div>
    </section>
  );
}
